import axios from 'axios';
import { withFreshAuth } from './freshAuth';
import { ENDPOINTS } from '../config/endpoints';

// Голосовые отпечатки живут в bit-history — там же Mongo и данные пользователя.
const API_BASE_URL = ENDPOINTS.history;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use(withFreshAuth);

export const voiceService = {
  // Функция за флагом и поимённым списком аккаунтов (биометрия). Аккаунту вне
  // списка сервис отвечает так, будто её нет, — прячем галочку и раздел ЛК.
  async status() {
    try {
      const response = await api.get('/voiceprints/status');
      return !!response.data?.enabled;
    } catch (e) {
      return false;
    }
  },

  async list() {
    const response = await api.get('/voiceprints');
    return response.data?.items || [];
  },

  async remove(id) {
    await api.delete(`/voiceprints/${id}`);
  },

  // Отрицательный сигнал: узнали неверно. Имя не шлём — на стороне сервиса
  // событие нужно только для счёта ложных срабатываний и калибровки порога.
  async reject(taskId, speakerId) {
    const response = await api.post('/voiceprints/reject', {
      task_id: taskId,
      label: speakerId,
    });
    return response.data;
  },

  // assignments: { SPEAKER_00: 'Иван Петров' } — метки из расшифровки, не отображаемые имена
  async remember(taskId, assignments) {
    const response = await api.post('/voiceprints/remember', {
      task_id: taskId,
      assignments,
    });
    return response.data; // { saved, names }
  },
};
